'use strict';

angular.module('cimerFrontEndApp').controller('MySurveysCtrl', ['$scope', 'SurveyService', '$location', 'Session', function ($scope, SurveyService, $location,Session) {

    if (!Session.getSessionObject().isAuthenticated) {
        $location.url('/');
        return;
    }

    $scope.mySurveys = [];

    var getMyActiveSurveys = function() {
        SurveyService.getMyActiveSurveys().then(function(result) {
            $scope.mySurveys = result;
        }, function() {
            $location.path('error');
        });
    };
    getMyActiveSurveys();

    $scope.loadAssignedSurvey = function (surveyObj) {

        SurveyService.setSurveyParameters(surveyObj);

        $location.path('survey');
        return;

    };

}]);
